import 'react-multi-carousel/lib/styles.css';
import TrademarkRegistration from '../components/trademark/TrademarkRegistration';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { v1 } from 'uuid';
import Router, { useRouter } from 'next/router';
import ProductChat from '../components/product/ProductChat';

import { xVerifyService } from 'services';
import { checkEmail } from '../helpers/emailChecker';
import { usePrevious } from '../hooks';
import { NextSeo } from 'next-seo';
import ProductHeader from '../components/product/ProductHeader';
import { Container } from 'react-bootstrap';
import Box from '@mui/material/Box';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import styled from 'styled-components';

import {
  clearAllSessions,
  clearLocalValue,
  restoreLocalValue,
} from '../_helpers/storage';
import { KEY_ORDER_AFTER_PAYMENT } from '../variables/Variables';
import { IMask } from 'react-imask';
import { config } from '_config';
import {
  checkIfFileAllowed,
  getFileExtension,
  getFileExtensionsString,
} from '../_helpers/utils';
import {
  pickCidFromSearchParams,
  resolveTmCampaignIdFromCid,
} from '../_helpers/campaign';

import ProgressBar from 'components/atomic/ProgressBar';

const { apiUrl } = config;

const cardInfo = {
  id: v1(),
  goods: 'true',
  goodsCategory: null,
  clazz: null,
  goodsServiceDetail: null,
  descriptions: [],
};
const initialList = [cardInfo];
const items = [
  {
    header: 'Trusted by Over 10,000 Trademark Filers',
    text: "We've successfully filed over 10,000 trademark applications",
  },

  {
    header: '1-Day Express Processing Available',
    text: 'With our premier option, we can complete your search within 1 business day, and file the application after you have approved it.',
  },
  {
    header: 'Trademark Monitoring',
    text: (
      <>
        <span>1 Month</span> of free trademark monitoring included to ensure no
        infringements on your mark are filed.
      </>
    ),
  },
  {
    header: 'Prepare & Reviewed by Our Specialists',
    text: 'Have peace of mind knowing our specialists will research your mark, file for you, and deal with minor roadblocks',
  },
  {
    header: '100% Satisfaction Guaranteed',
    text: '',
  },
];
const StyledItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  align-items: flex-end;
  gap: 30px;
  padding-right: 30px;
`;
const StyledRightContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledLeftContainer = styled.div`
  display: flex;
`;
const StyledItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  width: 550px;
`;
const StyledItemHeader = styled.div`
  font-family: MontserratBold;
  font-size: 18px;
`;
const StyledDescription = styled.div`
  font-family: MontserratRegular;
  font-size: 14px;

  span {
    font-family: MontserratBold;
  }
`;
export default function RegistrationTrademark() {
  const steps = ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'Step 5'];

  const router = useRouter();
  const [freeSearchVisible, setFreeSearchVisible] = useState(false);

  const orderSearch = [
    {
      code: 'TRADEMARK_Trademark_Search_Basic',
      desc: 'Includes a basic search of USPTO database only',
      popular: false,
      recommended: false,
      option: 'BASIC',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Federal_State',
      desc: 'Includes a search of USPTO, and state databases of similar names, logos, or slogans that are registered, or pending registration.',
      popular: true,
      recommended: false,
      option: 'BASIC',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Common_Law',
      desc: 'Includes USPTO and state database searches, as well as common law, corporate directories, and domain name registries for similar names, logos, or slogans.',
      popular: false,
      recommended: true,
      option: 'BASIC',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Global',
      desc: 'Includes all of the above searches, as well as the European Community and the World Intellectual Property Organization (WIPO)',
      popular: false,
      recommended: false,
      option: 'BASIC',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Basic',
      desc: 'Includes a basic search of USPTO database only',
      popular: false,
      recommended: false,
      option: 'PREMIER',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Federal_State',
      desc: 'Includes a search of USPTO, and state databases of similar names, logos, or slogans that are registered, or pending registration.',
      popular: true,
      recommended: false,
      option: 'PREMIER',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Common_Law',
      desc: 'Includes USPTO and state database searches, as well as common law, corporate directories, and domain name registries for similar names, logos, or slogans.',
      popular: false,
      recommended: true,
      option: 'PREMIER',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Global',
      desc: 'Includes all of the above searches, as well as the European Community and the World Intellectual Property Organization (WIPO)',
      popular: false,
      recommended: false,
      option: 'PREMIER',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Basic',
      desc: 'Includes a basic search of USPTO database only',
      popular: false,
      recommended: false,
      option: 'DELUXE',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Federal_State',
      desc: 'Includes a search of USPTO, and state databases of similar names, logos, or slogans that are registered, or pending registration.',
      popular: true,
      recommended: false,
      option: 'DELUXE',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Common_Law',
      desc: 'Includes USPTO and state database searches, as well as common law, corporate directories, and domain name registries for similar names, logos, or slogans.',
      popular: false,
      recommended: true,
      option: 'DELUXE',
    },
    {
      code: 'TRADEMARK_Trademark_Search_Global',
      desc: 'Includes all of the above searches, as well as the European Community and the World Intellectual Property Organization (WIPO)',
      popular: false,
      recommended: false,
      option: 'DELUXE',
    },
  ];
  const [searchProductList, setSearchProductList] = useState(null);

  const registerTrademarks = [
    { code: 'TRADEMARK_RegisterTrademark', option: 'BASIC' },
    { code: 'TRADEMARK_RegisterTrademark', option: 'PREMIER' },
    { code: 'TRADEMARK_RegisterTrademark', option: 'DELUXE' },
  ];
  const [trademarkRushProcessing, setTrademarkRushProcessing] = useState({
    code: 'TRADEMARK_Trademark_Rush_Processing',
  });
  const [registerTrademarkList, setRegisterTrademarkList] = useState(null);
  const [tokenValid, setTokenValid] = useState(true);
  useEffect(() => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    const fetchPrice = async (processingOptions, discountCouponType) => {
      const params = { onlyForSale: false };
      if (discountCouponType) params.discountCouponType = discountCouponType;
      if (processingOptions) params.processingOptions = processingOptions;
      axios
        .get(apiUrl + '/category/TRADEMARKS/products/prices', {
          params: params,
          headers: { 'Content-Type': 'application/json' },
        })
        .then((response) => {
          if (response.status === 200) {
            response.data
              .filter((product) => product.code.code.includes('Search'))
              .forEach((searchProduct) => {
                for (const element of orderSearch) {
                  if (
                    element.code === searchProduct.code.code &&
                    element.option === searchProduct.option
                  ) {
                    element.price = searchProduct.price;
                    element.customerName = searchProduct.code.customerName;
                  }
                }
              });
            setSearchProductList(orderSearch);
            response.data
              .filter(
                (product) => product.code.code === 'TRADEMARK_RegisterTrademark'
              )
              .forEach((registerTrademark) => {
                for (const element of registerTrademarks) {
                  if (
                    element.code === registerTrademark.code.code &&
                    element.option === registerTrademark.option
                  ) {
                    element.price = registerTrademark.price;
                    element.customerName = registerTrademark.code.customerName;
                  }
                }
              });
            setRegisterTrademarkList(registerTrademarks);
            response.data
              .filter((product) =>
                product.code.code.includes(
                  'TRADEMARK_Trademark_Rush_Processing'
                )
              )
              .forEach((rushTrademark) => {
                trademarkRushProcessing.price = rushTrademark.price;
                trademarkRushProcessing.customerName =
                  rushTrademark.code.customerName;
                setTrademarkRushProcessing(trademarkRushProcessing);
              });
            const product = JSON.parse(localStorage.getItem('product'));
            const freeSearchString = sessionStorage.getItem('freeSearchString');
            const historyPath = localStorage.getItem('path');
            if (
              historyPath &&
              historyPath === 'trademark-registration' &&
              product
            ) {
              if (product.step < steps.length)
                setState({
                  ...product,
                  markDesc: product?.markDesc || freeSearchString || '',
                });
            }
          }
        })
        .catch((error) => {
          if (error.request) {
            let salePage = window.location.href;
            let salePageURLArr = salePage.split('/');
            let salePageURL = (
              salePageURLArr[0] +
              '//' +
              salePageURLArr[2]
            ).replace(/\/+$/, '');
            const params = {
              onlyForSale: false,
              processingOptions: processingOptions,
            };
            if (discountCouponType)
              params.discountCouponType = discountCouponType;
            axios
              .get(
                `${salePageURL}/crm` + '/category/TRADEMARKS/products/prices',
                {
                  params: params,
                  headers: { 'Content-Type': 'application/json' },
                }
              )
              .then((response) => {
                if (response.status === 200) {
                  response.data
                    .filter((product) => product.code.code.includes('Search'))
                    .forEach((searchProduct) => {
                      for (const element of orderSearch) {
                        if (
                          element.code === searchProduct.code.code &&
                          element.option === searchProduct.option
                        ) {
                          element.price = searchProduct.price;
                          element.customerName =
                            searchProduct.code.customerName;
                        }
                      }
                    });
                  setSearchProductList(orderSearch);
                  response.data
                    .filter(
                      (product) =>
                        product.code.code === 'TRADEMARK_RegisterTrademark'
                    )
                    .forEach((registerTrademark) => {
                      for (const element of registerTrademarks) {
                        if (
                          element.code === registerTrademark.code.code &&
                          element.option === registerTrademark.option
                        ) {
                          element.price = registerTrademark.price;
                          element.customerName =
                            registerTrademark.code.customerName;
                        }
                      }
                    });
                  setRegisterTrademarkList(registerTrademarks);
                  response.data
                    .filter((product) =>
                      product.code.code.includes(
                        'TRADEMARK_Trademark_Rush_Processing'
                      )
                    )
                    .forEach((rushTrademark) => {
                      trademarkRushProcessing.price = rushTrademark.price;
                      trademarkRushProcessing.customerName =
                        rushTrademark.code.customerName;
                      setTrademarkRushProcessing(trademarkRushProcessing);
                    });
                  const product = JSON.parse(localStorage.getItem('product'));
                  const freeSearchString =
                    sessionStorage.getItem('freeSearchString');
                  const historyPath = localStorage.getItem('path');
                  if (
                    historyPath &&
                    historyPath === 'trademark-registration' &&
                    product
                  ) {
                    setState({
                      ...product,
                      markDesc: product?.markDesc || freeSearchString || '',
                    });
                  }
                }
              })
              .catch((error) => {});
          }
        });
    };
    if (restoreLocalValue(KEY_ORDER_AFTER_PAYMENT)) {
      clearLocalValue('crmSessionId');
      clearLocalValue(KEY_ORDER_AFTER_PAYMENT);
      clearAllSessions();
      delete router.query.step;
      router.push(router);
    }
    if (params.order && params.token) {
      const order = params.order;
      const token = params.token;
      const cid = pickCidFromSearchParams(params);
      axios
        .get(apiUrl + '/orders/' + order, {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        .then((orderResponse) => {
          let product = orderResponse.data.products[0];
          if (product.paymentStatus !== 'Lead') {
            fetchPrice(product.option, null);
          } else {
            let tokenObj = { token: token, orderUids: [order] };
            localStorage.setItem('token', JSON.stringify(tokenObj));
            localStorage.setItem('tokenDiscount', token);
            if (orderResponse.data.products[0].updated) {
              localStorage.setItem('updated', orderResponse.data.order.updated);
            }
            let maskedPhone = IMask.createMask({
              mask: '(000) 000-0000',
            });
            maskedPhone.resolve(product.individual.phone);
            let trademarkProduct = {
              ...state,
              trademarkType: product.trademarkType,
              markDesc: product.markDesc,
              literalElements: product.literalElements,
              logoColoredVariety: product.logoColoredVariety ? 'true' : 'false',
              colorsInLogo: product.colorsInLogo,
              isIncludeLivingPersonName:
                product.includedName === 'NONE' ? 'false' : 'true',
              isIncludeNicknameName:
                product.includedName === 'OWNER_NAME' ? 'true' : 'false',
              ownName:
                product.includedName === 'OWNER_NAME'
                  ? product.includedNameValue
                  : null,
              isOtherLivingName:
                product.includedName === 'OTHER_LIVING_NAME' ? 'true' : 'false',
              otherLivingName:
                product === 'OTHER_LIVING_NAME'
                  ? product.includedNameValue
                  : null,
              includeTranslationWords: product.includeTranslationWords
                ? 'true'
                : 'false',
              translation: product.translation,
              currentTrademark: product.currentTrademark ? 'true' : 'false',
              firstName: product.individual.firstName,
              lastName: product.individual.lastName,
              countryOfCitizenship: product.individual.countryOfCitizenship,
              email: product.individual.email,
              phone: maskedPhone.value,
              address: product.individual.address.address1,
              city: product.individual.address.city,
              state: product.individual.address.state,
              zip: product.individual.address.zip,
              coOwners: product.coOwners,
              individualOrgOrInd: product.organization
                ? 'Organization'
                : 'Individual',
            };
            const campaignId = resolveTmCampaignIdFromCid(cid);
            if (campaignId) {
              trademarkProduct.campaignId = campaignId;
            }
            if (product.organization) {
              trademarkProduct.isNonUsBased = product.organization.usBased
                ? 'USBased'
                : 'NonUSBased';
              trademarkProduct.orgName = product.organization.name;
              trademarkProduct.orgType = product.organization.type;
              trademarkProduct.orgPosition = product.organization.position;
              if (product.organization.usBased) {
                trademarkProduct.orgState =
                  product.organization.stateOrCountryOfFormation;
              } else {
                trademarkProduct.formationCountry =
                  product.organization.stateOrCountryOfFormation;
              }
            }
            if (product.classes.length > 0) {
              product.classes.forEach((classElement) => {
                classElement.goods = classElement.goods ? 'true' : 'false';
              });
              trademarkProduct.classes = product.classes;
              trademarkProduct.step = 3;
            } else {
              trademarkProduct.step = 2;
            }
            if (orderResponse.data.order.processingOption !== 'STANDARD') {
              trademarkProduct.option =
                orderResponse.data.order.processingOption;
              trademarkProduct.searchType =
                orderResponse.data.order.processingOption === 'BASIC'
                  ? 'TRADEMARK_Trademark_Search_Basic'
                  : 'TRADEMARK_Trademark_Search_Federal_State';
              trademarkProduct.step = 4;
            }
            if (product.firstUseAnywhere) {
              const firstUseAnywhereDate = new Date(product.firstUseAnywhere);
              trademarkProduct.firstUseAnywhereYear =
                firstUseAnywhereDate.getFullYear();
              trademarkProduct.firstUseAnywhereMonth =
                firstUseAnywhereDate.getMonth() + 1;
              trademarkProduct.firstUseAnywhereDay =
                firstUseAnywhereDate.getDay();
            }
            if (product.firstUseInCommerce) {
              const firstUseInCommerce = new Date(product.firstUseInCommerce);
              trademarkProduct.firstUseInCommerceYear =
                firstUseInCommerce.getFullYear();
              trademarkProduct.firstUseInCommerceMonth =
                firstUseInCommerce.getMonth() + 1;
              trademarkProduct.firstUseInCommerceDay =
                firstUseInCommerce.getDay();
            }
            if (product.trademarkType === 'LOGO') {
              if (
                product.processingResult?.files &&
                product.processingResult?.files.TRADEMARK_LOGO
              ) {
                fetch(
                  apiUrl +
                    '/orders/' +
                    order +
                    '/products/' +
                    product.id +
                    '/result-PDF?fileType=TRADEMARK_LOGO',
                  {
                    method: 'GET',
                    headers: {
                      Authorization: 'Bearer ' + token,
                    },
                  }
                )
                  .then((response) => response.blob())
                  .then((blob) => {
                    setImageLogoSrc(URL.createObjectURL(blob));
                    setImageLogoExist(true);
                  });
              }
            }
            setState(trademarkProduct);
            fetchPrice(
              product.option,
              orderResponse.data.order.discountCouponType
            );
          }
        })
        .catch((error) => {
          fetchPrice(null, null);
          if (error.response.status === 403) {
            setTokenValid(false);
            localStorage.removeItem('path');
            localStorage.removeItem('product');
            localStorage.removeItem('token');
            localStorage.removeItem('tokenDiscount');
            localStorage.removeItem('updated');
          }
        });
    } else {
      fetchPrice(null, null);
    }
  }, []);
  const [state, setState] = React.useState(() => {
    let markDesc = null;

    if (typeof window !== 'undefined') {
      markDesc = sessionStorage.getItem('freeSearchString');
    }

    return {
      code: 'TRADEMARK',
      trademarkType: 'NAME',
      markDesc,
      literalElements: null,
      logoColoredVariety: 'true',
      colorsInLogo: null,
      ownName: null,
      isIncludeLivingPersonName: 'false',
      isOtherLivingName: 'false',
      otherLivingName: null,
      isIncludeNicknameName: 'false',
      includeTranslationWords: 'false',
      translation: null,
      currentTrademark: 'false',
      firstUseAnywhereYear: null,
      firstUseAnywhereMonth: null,
      firstUseAnywhereDay: null,
      firstUseInCommerceYear: null,
      firstUseInCommerceMonth: null,
      firstUseInCommerceDay: null,
      individualOrgOrInd: 'Individual',
      isNonUsBased: 'USBased',
      firstName: null,
      lastName: null,
      countryOfCitizenship: 'US',
      address: null,
      city: null,
      state: null,
      zip: null,
      phone: null,
      email: null,
      orgName: null,
      orgType: null,
      otherOrgType: null,
      orgState: null,
      formationCountry: 'US',
      orgPosition: null,
      classes: initialList,
      searchType: 'TRADEMARK_Trademark_Search_Basic',
      registerTrademarkType: 'TRADEMARK_RegisterTrademark',
      option: 'STANDARD',
      trademarkRushType: 'TRADEMARK_Trademark_Rush_Processing',
      coOwners: [],
      rushProcessing: true,
      verifying: false,
      verificationResult: {},
      lead: false,
      step: 0,
      campaignId: null,
      isFileInvalidSize: '',
      consentToGetSMS: true,
    };
  });

  const [imageLogo, setImageLogo] = React.useState();
  const [isImageLogoExist, setImageLogoExist] = React.useState(false);
  const [imageLogoSrc, setImageLogoSrc] = React.useState();
  const [allowedExtensions, setAllowedExtensions] = React.useState('');
  const [allowedExtensionsArray, setAllowedExtensionsArray] =
    React.useState('');

  const prevState = usePrevious(state);

  useEffect(() => {
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );

    let url =
      apiUrl + '/category/products/TRADEMARK_RegisterTrademark/file-types';
    let fallbackUrl =
      `${salePageURL}/crm` +
      '/category/products/TRADEMARK_RegisterTrademark/file-types';
    axios
      .get(url, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200) {
          response.data
            .filter((file) => file.code.includes('TRADEMARK_LOGO'))
            .forEach((allowedFile) => {
              setAllowedExtensions(
                getFileExtensionsString(allowedFile.allowedExtensions)
              );
              setAllowedExtensionsArray(allowedFile.allowedExtensions);
            });
        }
      })
      .catch((error) => {
        if (error.request) {
          axios
            .get(fallbackUrl, {
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
              if (response.status === 200) {
                response.data
                  .filter((file) => file.code.includes('TRADEMARK_LOGO'))
                  .forEach((allowedFile) => {
                    setAllowedExtensions(
                      getFileExtensionsString(allowedFile.allowedExtensions)
                    );
                    setAllowedExtensionsArray(allowedFile.allowedExtensions);
                  });
              }
            })
            .catch((error) => {});
        }
      });
  }, []);

  const verifyEmail = useCallback(() => {
    if (!state.verificationResult?.email && checkEmail(state.email)) {
      setState((prevState) => ({ ...prevState, verifying: true }));
      let emailValue = state.email;
      if (
        emailValue.indexOf('+') > -1 &&
        emailValue.indexOf('gmail.com') > -1
      ) {
        emailValue =
          emailValue.substring(0, emailValue.indexOf('+')) +
          emailValue.substring(emailValue.indexOf('@'), emailValue.length);
      }
      xVerifyService.verifyEmail(emailValue).then((result) => {
        setState((prevState) => {
          return {
            ...prevState,
            verificationResult: {
              ...prevState.verificationResult,
              email: result,
            },
            verifying: false,
          };
        });
      });
    }
  }, [state]);

  const handleBlur = useCallback(
    (e) => {
      const { type } = e.target;
      if (type === 'email') {
        verifyEmail();
      }
    },
    [verifyEmail]
  );

  function handleChange(e) {
    if (e.target.name) {
      if (
        e.target.name === 'rushProcessing' ||
        e.target.name === 'consentToGetSMS'
      ) {
        setState({ ...state, [e.target.name]: e.target.checked });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.name]: e.target.checked })
        );
      } else {
        if (e.target.name === 'option') {
          setState({
            ...state,
            [e.target.name]: e.target.value,
            searchType:
              e.target.value === 'BASIC'
                ? 'TRADEMARK_Trademark_Search_Basic'
                : 'TRADEMARK_Trademark_Search_Federal_State',
          });
          localStorage.setItem(
            'product',
            JSON.stringify({
              ...state,
              [e.target.name]: e.target.value,
              searchType:
                e.target.value === 'BASIC'
                  ? 'TRADEMARK_Trademark_Search_Basic'
                  : 'TRADEMARK_Trademark_Search_Federal_State',
            })
          );
        } else {
          if (e.target.type === 'email') {
            setState({
              ...state,
              [e.target.name]: e.target.value,
              verificationResult: {
                ...state.verificationResult,
                [e.target.name]: null,
              },
            });
            localStorage.setItem(
              'product',
              JSON.stringify({
                ...state,
                [e.target.name]: e.target.value,
                verificationResult: {
                  ...state.verificationResult,
                  [e.target.name]: null,
                },
              })
            );
          } else {
            setState({ ...state, [e.target.name]: e.target.value });
            localStorage.setItem(
              'product',
              JSON.stringify({ ...state, [e.target.name]: e.target.value })
            );
          }
        }
      }
    } else {
      if (e.target.type === 'email') {
        setState({
          ...state,
          [e.target.id]: e.target.value,
          verificationResult: {
            ...state.verificationResult,
            [e.target.id]: null,
          },
        });
        localStorage.setItem(
          'product',
          JSON.stringify({
            ...state,
            [e.target.id]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.id]: null,
            },
          })
        );
      } else if (e.target.type === 'file') {
        setState((prevState) => ({
          ...prevState,
          isFileInvalidSize: '',
        }));
        if (!e.target.files || e.target.files.length === 0) {
          setImageLogo(undefined);
        } else {
          const formFileExt = getFileExtension(e.target.files[0].name);
          const isExtensionAllowed = checkIfFileAllowed(
            formFileExt,
            allowedExtensionsArray
          );
          if (isExtensionAllowed) {
            const fileSize = e.target.files[0]?.size;
            if (fileSize && fileSize / 1024 / 1024 <= 5) {
              setImageLogo(e.target.files[0]);
            } else {
              setState((prevState) => ({
                ...prevState,
                isFileInvalidSize: 'File size limit is 5MB',
              }));
            }
          } else {
            setState((prevState) => ({
              ...prevState,
              isFileInvalidSize:
                'Incorrect file type. Allowed ' + allowedExtensions,
            }));
          }
        }
      } else {
        setState({ ...state, [e.target.id]: e.target.value });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.id]: e.target.value })
        );
      }
    }
    localStorage.setItem('path', 'trademark-registration');
  }
  useEffect(() => {
    if (!imageLogo) {
      setImageLogoSrc(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(imageLogo);
    setImageLogoSrc(objectUrl);
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [imageLogo]);
  function handleCoOwners(coOwners) {
    setState({ ...state, coOwners: coOwners });
    localStorage.setItem(
      'product',
      JSON.stringify({ ...state, coOwners: coOwners })
    );
    localStorage.setItem('path', 'trademark-registration');
  }

  function handleCategories(classes) {
    setState({ ...state, classes: classes });
    localStorage.setItem(
      'product',
      JSON.stringify({ ...state, classes: classes })
    );
    localStorage.setItem('path', 'trademark-registration');
  }

  function handleStep(value) {
    if (value >= steps.length) {
      value = 0;
      setState({
        ...state,
        lead: false,
        step: value,
        registerTrademarkType: 'TRADEMARK_RegisterTrademark',
      });
      localStorage.setItem(
        'product',
        JSON.stringify({
          ...state,
          step: value,
          registerTrademarkType: 'TRADEMARK_RegisterTrademark',
        })
      );
    } else {
      if (!state.lead && value === 2) {
        setState({
          ...state,
          lead: true,
          step: value,
          registerTrademarkType: 'TRADEMARK_RegisterTrademark',
        });
        localStorage.setItem(
          'product',
          JSON.stringify({
            ...state,
            lead: true,
            step: value,
            registerTrademarkType: 'TRADEMARK_RegisterTrademark',
          })
        );
      } else {
        setState({
          ...state,
          step: value,
          registerTrademarkType: 'TRADEMARK_RegisterTrademark',
        });
        localStorage.setItem(
          'product',
          JSON.stringify({
            ...state,
            step: value,
            registerTrademarkType: 'TRADEMARK_RegisterTrademark',
          })
        );
      }
    }
    localStorage.setItem('path', 'trademark-registration');
    router.push('/registration-trademark-search?step=' + value, undefined, {
      shallow: true,
    });
    Router.events.on('routeChangeComplete', () => {
      document.querySelector('#__next').scrollTo(0, 0);
    });
  }

  useEffect(() => {
    if (router.query.step) {
      const product = localStorage.getItem('product');
      let value = parseInt(router.query.step, 10);
      if (
        (value > 0 &&
          state.trademarkType === 'LOGO' &&
          imageLogo === undefined) ||
        isImageLogoExist
      ) {
        router.push('/registration-trademark-search?step=0', undefined, {
          shallow: true,
        });
      } else {
        setState({ ...state, step: value });
      }

      if (value >= steps.length || !product) {
        value = 0;
      }

      setState({ ...state, step: value });
    }
  }, [router.query.step]);

  useEffect(() => {
    if (prevState?.email === null) {
      verifyEmail();
    }
  }, [prevState, verifyEmail]);

  const [leftSideHeight, setLeftSideHeight] = useState(0);
  const rightSide = React.useRef();

  useEffect(() => {
    const i = setInterval(() => {
      const rHeight = rightSide.current?.clientHeight;
      setLeftSideHeight(rHeight);
    }, 500);

    const rHeight = rightSide.current?.clientHeight;
    setLeftSideHeight(rHeight);

    setTimeout(() => {
      clearInterval(i);
    }, 5000);
  }, [rightSide.current?.clientHeight]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (rightSide.current) {
        rightSide.current?.scrollIntoView();
      } else {
        window.scroll(0, 0);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [rightSide.current]);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      sessionStorage.getItem('freeSearchString') &&
      sessionStorage.getItem('freeSearchString') === state.markDesc
    ) {
      setFreeSearchVisible(true);
    } else {
      setFreeSearchVisible(false);
    }
  }, [state]);

  useEffect(() => {
    let timeout;

    function handleRouteChangeComplete() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        window.scroll(0, 0);
      }, 100);
    }

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      clearTimeout(timeout);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);

  return (
    <div className="reg">
      <NextSeo title="Trademark Registration" />
      <div className="banner mobile"></div>
      {config.skin === 'v2-basic' && (
        <div className="filing-banner-outer-container">
          <div className="filing-banner-inner-container">
            {freeSearchVisible && (
              <div className="filing-top-subtitle">
                <b>{sessionStorage.getItem('freeSearchString')}</b>&nbsp; is
                Available to Register
              </div>
            )}
            <div className="desktop">
              <ProductHeader
                classes={freeSearchVisible ? 'tm-reg-filing' : ''}
                header="Official"
                header2="US Trademark Registration"
              />{' '}
            </div>
            <div className="mobile">
              <ProductHeader
                header="Official"
                header2="US Trademark Registration"
              />
            </div>
            <ProgressBar value={state.step + 1} maxValue={steps.length} />
          </div>
        </div>
      )}
      <div className="side-wrapper">
        {state.step > 3 && (
          <div className="left-side">
            <div className="banner" style={{ height: leftSideHeight }}>
              <div className="summary">
                <h3>Trademark Summary</h3>
                <div className="step-box">
                  <h5 style={{ textTransform: 'uppercase' }}>
                    TRADEMARK {state.trademarkType}
                  </h5>
                  {state.markDesc ? <p>{state.markDesc}</p> : ''}
                  {(imageLogo || isImageLogoExist) &&
                    state.trademarkType === 'LOGO' && (
                      <img
                        style={{ maxWidth: '400px', maxHeight: '100px' }}
                        src={imageLogoSrc}
                      />
                    )}
                </div>
                {state.step > 0 ? (
                  <div className="step-box">
                    <h5>OWNER OF TRADEMARK {state.trademarkType}</h5>
                    <p>
                      {state.firstName ? state.firstName : ''}{' '}
                      {state.lastName ? state.lastName : ''}, United States
                    </p>
                    <p>
                      {state.address ? state.address : ''}{' '}
                      {state.city ? state.city : ''}{' '}
                      {state.state ? state.state : ''}{' '}
                      {state.zip ? state.zip : ''}
                    </p>
                    <p>
                      {state.phone ? state.phone : ''}{' '}
                      {state.email ? state.email : ''}
                    </p>
                  </div>
                ) : null}
                {state.step > 1 ? (
                  <div className="step-box">
                    <h5>YOU SELL</h5>
                    {state.classes.map((item) => (
                      <>
                        <p>{item.goods === 'true' ? 'GOODS' : 'SERVICE'}</p>
                        {item.goodsCategory ? (
                          <>
                            <h5>CATEGORY</h5>
                            <p>{item.goodsCategory}</p>
                          </>
                        ) : (
                          ''
                        )}
                        {item.goodsCategory && item.goodsServiceDetail ? (
                          <>
                            <h5>DETAILS ABOUT YOUR TRADEMARK</h5>
                            <p> {item.goodsServiceDetail}</p>
                          </>
                        ) : (
                          ''
                        )}
                      </>
                    ))}
                  </div>
                ) : (
                  ''
                )}
                {state.step > 2 ? (
                  state.option === 'STANDARD' ? (
                    ''
                  ) : (
                    <>
                      <div className="step-box">
                        <h5>PACKAGE</h5>
                        <p>
                          {registerTrademarkList
                            ? registerTrademarkList.filter(
                                (registerTrademarkProduct) =>
                                  registerTrademarkProduct.code ===
                                    state.registerTrademarkType &&
                                  registerTrademarkProduct.option ===
                                    state.option
                              )[0]?.customerName
                            : ''}
                          {' ' + state.option}
                        </p>
                      </div>
                      <div className="step-box">
                        <h5>TRADEMARK SEARCH PACKAGE</h5>
                        <p>
                          {searchProductList
                            ? searchProductList.filter(
                                (searchProduct) =>
                                  searchProduct.code === state.searchType
                              )[0].customerName
                            : ''}
                        </p>
                      </div>
                    </>
                  )
                ) : (
                  ''
                )}
                {state.step > 3 && state.rushProcessing ? (
                  <div className="step-box">
                    <h5>THE PROCESSING SPEED</h5>
                    <p>
                      Rush Priority Processing. Next day processing when you
                      need mark filed quickly.
                    </p>
                  </div>
                ) : null}
                <ProductChat />
              </div>
            </div>
          </div>
        )}
        {state.step < 3 && (
          <div className="left-side">
            <StyledItemsContainer>
              {items &&
                items.map((item, j) => (
                  <StyledItem isBlue={item.isBlue} key={j}>
                    <StyledLeftContainer>
                      <CheckCircleOutlineIcon
                        style={{ float: 'right', marginRight: '10px' }}
                      />
                    </StyledLeftContainer>
                    <StyledRightContainer>
                      <StyledItemHeader>{item.header}</StyledItemHeader>
                      <StyledDescription>{item.text}</StyledDescription>
                    </StyledRightContainer>
                  </StyledItem>
                ))}
            </StyledItemsContainer>
          </div>
        )}
        <div
          className={state.step === 3 ? 'right-side-main' : 'right-side'}
          id="rightSide"
          ref={config.skin === 'v2-basic' ? null : rightSide}
        >
          <div className="form">
            {tokenValid ? (
              <TrademarkRegistration
                state={state}
                onChange={handleChange}
                onBlur={handleBlur}
                onStep={handleStep}
                imageLogo={imageLogo}
                imageLogoSrc={imageLogoSrc}
                searchProductList={searchProductList}
                registerTrademarkList={registerTrademarkList}
                trademarkRushProcessing={trademarkRushProcessing}
                onHandleCategories={handleCategories}
                onHandleCoOwners={handleCoOwners}
                steps={steps}
                allowedExtensions={allowedExtensions}
              />
            ) : (
              <Box sx={{ width: '100%' }}>
                <Container className="md-container">
                  <div className="desktop">
                    <ProductHeader
                      header="Official"
                      header2="US Trademark Registration"
                    />{' '}
                  </div>
                  <div className="mobile">
                    <ProductHeader
                      header="Official"
                      header2="US Trademark Registration"
                    />
                  </div>
                  <div style={{ color: 'red' }}>This offer has expired</div>
                </Container>
              </Box>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
